import { LanguageMap } from '../resources/istatement/language_map';
import { IAttachment } from '../resources/istatement/attachment';
import { Utils } from '../utils';
import { Versions } from '../constants/versions';

export interface AttachmentParams extends Partial<IAttachment> {
	content?: ArrayBuffer | string;
}

export class Attachment {
	usageType?: string;
	display?: LanguageMap;
	contentType?: string;
	length?: number;
	sha2?: string;
	description?: { [key: string]: string };
	fileUrl?: string;
	content?: ArrayBuffer;

	constructor(cfg: AttachmentParams = {}) {
		const { contentType, length, sha2, usageType, display, description, fileUrl } = cfg;

		this.contentType = contentType;
		this.length = length;
		this.sha2 = sha2;
		this.usageType = usageType;
		this.display = display;
		this.description = description;
		this.fileUrl = fileUrl;

		if (cfg.content) {
			if (typeof cfg.content === 'string') {
				this.setContentFromString(cfg.content);
			} else {
				this.setContent(cfg.content);
			}
		}
	}

	asVersion(version: Versions = '1.0.3'): IAttachment {
		const { contentType, display, length, sha2, usageType, fileUrl, description } = this;
		const result: Partial<IAttachment> = {
			contentType,
			display,
			length,
			sha2,
			usageType,
			fileUrl,
			description
		};

		return result as IAttachment;
	}

	getLangDictionaryValue = Utils.getLangDictionaryValue;

	setContent(content: ArrayBuffer): void {
		this.content = content;
		this.length = content.byteLength;
		//this.sha2 = Utils.getSHA256String(content);
	}

	setContentFromString(content: string): void {
		const _content = Utils.stringToArrayBuffer(content);
		this.setContent(_content);
	}

	getContentAsString(): string | undefined {
		return this.content && Utils.stringFromArrayBuffer(this.content);
	}

	fromJSON(attachmentJSON: string): Attachment {
		const _attachment = JSON.parse(attachmentJSON);

		return new Attachment(_attachment);
	}

	_defaultEncoding: string = 'utf-8';
}
